export default {
  processing: 'Обробка',
  success: 'Завершено',
  failed: 'Помилка'
};
